import {
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	ListItemText,
	makeStyles,
	MenuItem,
	TextField,
	Typography,
	IconButton,
	Icon,
	InputAdornment,
	Switch,
	Button
} from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import React, { useState } from 'react'
import DatePicker from 'react-multi-date-picker'
import DateObject from 'react-date-object'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import { states } from '../../../services/helpers'

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: '1fr 1fr 1fr',
		marginBottom: '23px'
	},
	gridFull: {
		display: 'grid',
		gridGap: '8px',
		gridTemplateColumns: '1fr',
		marginBottom: '50px'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: '1fr 1fr',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				width: '100%'
			}
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': { width: '100%', minWidth: '100%' },
		'& .MuiFormControl-root .MuiInputLabel-shrink': {
			zIndex: 1
		}
	},
	fullWidth: {
		'& .MuiTextField-root': { width: '100%', minWidth: '100%' },
		'& .MuiFormControl-root .MuiInputLabel-shrink': {
			zIndex: 1
		},
		width: '100%'
	},
	checkBox: {
		display: 'flex',
		flexDirection: 'row'
	},
	input: {
		display: 'none'
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '17px !important'
	},
	sharingWrapper: {
		height: 56,
		width: '100%',
		padding: '0px 12px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: 6,
		background: '#F9F9F9'
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	checked: {}
}))

const Holidays = (props) => {
	const [isCalendarOpen, setIsCalendarOpen] = useState(false)

	const [isEndCalendarOpen, setIsEndCalendarOpen] = useState(false)
	const classes = useStyles()
	let { holiday, setHoliday, clearHoliday, saveHoliday } = props

	const updateEndDate = (d) => {
		setHoliday({
			...holiday,
			endDate: d
		})
	}

	const updateStartDate = (d) => {
		setHoliday({
			...holiday,
			startDate: d
		})
	}

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	return (
		<Card style={{ maxWidth: '1245px', overflow: 'visible' }}>
			<CardHeader title="Boarding Holiday Setup" />
			<CardContent>
				<div className={classes.grid}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Title"
							variant="filled"
							value={holiday.name}
							onChange={(e) => setHoliday({ ...holiday, name: e.target.value })}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<KeyboardDatePicker
							disableToolbar
							style={{
								margin: 0,
								backgroundColor: '#FFFFFF'
							}}
							InputAdornmentProps={{
								position: 'end',
								component: () => (
									<IconButton onClick={() => setIsCalendarOpen(true)}>
										<Icon
											className="far fa-calendar-alt"
											style={{
												fontSize: '1.325rem'
											}}
										/>
									</IconButton>
								)
							}}
							InputProps={{
								error: false
							}}
							open={isCalendarOpen}
							onClose={() => setIsCalendarOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							label="Start Date"
							inputVariant="filled"
							value={holiday.startDate || null}
							onChange={(date) => {
								updateStartDate(date.clone().hour(12))
							}}
							className={classes.datePicker}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'Date',
								className: classes.calendarButton
							}}
							disablePast
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<KeyboardDatePicker
							disableToolbar
							style={{
								margin: 0
							}}
							InputAdornmentProps={{
								position: 'end',
								component: () => (
									<IconButton onClick={() => setIsEndCalendarOpen(true)}>
										<Icon
											className="far fa-calendar-alt"
											style={{
												fontSize: '1.325rem'
											}}
										/>
									</IconButton>
								)
							}}
							InputProps={{
								error: false
							}}
							open={isEndCalendarOpen}
							onClose={() => setIsEndCalendarOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							label="End Date"
							inputVariant="filled"
							value={holiday.endDate || null}
							onChange={(date) => {
								updateEndDate(date.clone().hour(12))
							}}
							className={classes.datePicker}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'Date',
								className: classes.calendarButton
							}}
							disablePast
						/>
					</div>
				</div>

				<div className={classes.gridFull}>
					<Typography
						variant="body2"
						style={{
							color: '#1a1a35',
							fontWeight: '800',
							fontSize: 12,
							letterSpacing: 0.75,
							textTransform: 'uppercase'
						}}>
						Surcharge Dates
					</Typography>
					<div className={clsx([classes.fullWidth])} style={{ position: 'relative' }}>
						{holiday.surcharge_dates.length ? (
							<Typography
								variant="body2"
								style={{
									position: 'absolute',
									top: 5,
									left: 7,
									fontSize: 12,
									fontFamily: 'Nunito',
									color: '#777679',
									zIndex: 1,
									fontWeight: '600'
								}}>
								Selected Dates
							</Typography>
						) : null}
						<DatePicker
							multiple={true}
							disabled={!holiday.startDate || !holiday.endDate}
							minDate={moment(holiday.startDate).toDate()}
							maxDate={moment(holiday.endDate).toDate()}
							value={holiday.surcharge_dates}
							onChange={(val) => {

								let mapped = val.map(v => {
									if (v.format) return v.format()
									return v
								})

								setHoliday({
									...holiday,
									surcharge_dates: mapped
								})
							}}
							placeholder="Selected Dates"
							format="MM/DD/YY"
							style={{
								width: '100%',
								height: 56,
								margin: 0,
								borderBottomLeftRadius: 0,
								borderBottomRightRadius: 0,
								backgroundColor: '#FFFFFF',
								border: '1px solid #D0CFD2',
								paddingTop: holiday.surcharge_dates.length ? 18 : 8,
								paddingLeft: 16,
								fontSize: 16,
								fontFamily: 'Nunito',
								color: '#777679',
								backgroundColor: holiday.startDate && holiday.endDate ? '#FFFFFF' : '#F9F9F9'
							}}
						/>
					</div>

					<div className={clsx([classes.fullWidth])} style={{ marginTop: 10, width: '50%' }}>
						<TextField
							id="price"
							variant="filled"
							label="Surcharge Fee"
							value={holiday.surcharge_fee}
							disabled={!holiday.surcharge_dates.length}
							style={{ width: '50%' }}
							onChange={(e) => {
								setHoliday({
									...holiday,
									surcharge_fee: e.target.value
								})
							}}
							value={formatNumsToDollars(onlyNumbers(holiday.surcharge_fee))}
							InputProps={{
								startAdornment: (
									<InputAdornment className={classes.currencyAdornment} position="start">
										$
									</InputAdornment>
								)
							}}
						/>
					</div>

					<div className={classes.gridFull} style={{ marginTop: 16 }}>
						<Typography
							variant="body2"
							style={{
								color: '#1a1a35',
								fontWeight: '800',
								fontSize: 12,
								letterSpacing: 0.75,
								textTransform: 'uppercase'
							}}>
							Blocked Pick-up and Drop-off Dates
						</Typography>
						<div className={clsx([classes.fullWidth])} style={{ position: 'relative' }}>
							{holiday.restricted_pick_drop_dates.length ? (
								<Typography
									variant="body2"
									style={{
										position: 'absolute',
										top: 5,
										left: 7,
										fontSize: 12,
										fontFamily: 'Nunito',
										color: '#777679',
										zIndex: 1,
										fontWeight: '600'
									}}>
									Selected Dates
								</Typography>
							) : null}
							<DatePicker
								multiple={true}
								disabled={!holiday.startDate || !holiday.endDate}
								minDate={moment(holiday.startDate).toDate()}
								maxDate={moment(holiday.endDate).toDate()}
								value={holiday.restricted_pick_drop_dates}
								onChange={(val) => {

									let mapped = val.map(v => {
										if (v.format) return v.format()
										return v
									})
	

									setHoliday({
										...holiday,
										restricted_pick_drop_dates: mapped
									})
								}}
								placeholder="Selected Dates"
								format="MM/DD/YY"
								style={{
									width: '100%',
									height: 56,
									margin: 0,
									borderBottomLeftRadius: 0,
									borderBottomRightRadius: 0,
									backgroundColor: '#FFFFFF',
									border: '1px solid #D0CFD2',
									paddingTop: holiday.restricted_pick_drop_dates.length ? 18 : 8,
									paddingLeft: 16,
									fontSize: 16,
									fontFamily: 'Nunito',
									color: '#777679',
									backgroundColor: holiday.startDate && holiday.endDate ? '#FFFFFF' : '#F9F9F9'
								}}
							/>
						</div>

						<div className={clsx([classes.fullWidth])} style={{ marginTop: 10, width: '50%' }}>
							<Typography
								variant="body2"
								style={{
									color: '#1a1a35',
									fontWeight: '800',
									fontSize: 12,
									letterSpacing: 0.75,
									textTransform: 'uppercase',
									marginBottom: 6
								}}>
								Deposit
							</Typography>
							<div className={classes.sharingWrapper}>
								<Typography
									style={{
										color: '#1a1a35',
										fontSize: 16,
										fontWeight: '600'
									}}>
									Require Deposit
								</Typography>
								<Switch
									checked={holiday.deposit_required}
									onChange={() => {
										setHoliday({
											...holiday,
											deposit_required: !holiday.deposit_required
										})
									}}
									name="sharingKennels"
									icon={
										<div className={classes.thumb}>
											<Icon className="far fa-times" />
										</div>
									}
									checkedIcon={
										<div className={classes.thumb}>
											<Icon className="far fa-check" />
										</div>
									}
									classes={{
										root: classes.switchRoot,
										switchBase: classes.switchBase,
										thumb: classes.thumb,
										track: classes.track,
										checked: classes.checked
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<Button
					variant="contained"
					color="secondary"
					disabled={!holiday.name || !holiday.startDate || !holiday.endDate}
					style={{ marginRight: '8px' }}
					onClick={() => saveHoliday(holiday)}>
					Save Holiday
				</Button>
				<Button
					variant="outlined"
					color="secondary"
					onClick={() => {
						clearHoliday()
					}}>
					Cancel
				</Button>
			</CardContent>
		</Card>
	)
}

export default Holidays
